import { overrideQuestionModel } from './override-question-model.js';
import store from "../store"

/////////////////////////////////////////////////////////////////////////////////
// The completion map
// caches the status of the questions
// and their path 

export const completionMap = {
  getAnswerValue: function(qid) {
    const which = store.getters.getEnumWhich(qid)
    const oq = overrideQuestionModel.questions.find(q => q.id == qid)
    return which < 0 ? which : oq.items[which].value
  },

  questionMap: null, // Private cache

  getQuestionMap: function() {
      if (this.questionMap == null) {
          this.questionMap = this.buildQuestionMap()
      }
      return this.questionMap
  },
  clearQuestionMap: function() {
    // console.log('clearQuestionMap()')
    this.questionMap = null
  },
  buildQuestionMap() {
    // For each question, resolve booleans:
    //   required (boolean)
    //   answered (boolean)
    //   mayBeUntouched (boolean) - may have been answered
    //                            - depends whether we have gone past it
    //   nextIndex (int)
    //   prevIndex (int)
    //   hasNext  (boolean)
    //   hasPrev  (boolean)

    // console.log('buildQuestionMap()')
    let qm = overrideQuestionModel.questions.map(q => {
        var roofMaterial, year, roofAge
        let required = true;
        let answered = store.getters.getQuestionAllUserSet(q.id)
        let mayBeUntouched = false;
        // Special cases - question may not be required, depending
        // on answers to earlier questions
        switch (q.id) {
            // case "C4": // Does not exist at present
            //     required = answers.windows < 0 || answers.windows == 103 /* casement */
            //     break;
            case "D6": // connections - Only ask for pre1980s metal/fibro roofs
              {
                roofMaterial = this.getAnswerValue('D4')
                year = this.getAnswerValue('D1')
                required = ((roofMaterial < 0)
                         || (roofMaterial == 401) /* metal */
                         || (roofMaterial == 403) /* fibro */)
                        && (year != 102) /* pre1980 */
              }
              break;
            case "D7": // roofOverBatten - Only ask for pre1980s metal/fibro roofs
              {
                roofMaterial = this.getAnswerValue('D4')
                year = this.getAnswerValue('D1')
                required = ((roofMaterial < 0)
                         || (roofMaterial == 401) /* metal */
                         || (roofMaterial == 403) /* fibro */)
                        && (year != 102) /* pre1980 */
              }
                break;
            case "D8": // roofSeaming - Only ask for tile roofs >10 yrs old
              {
                roofMaterial = this.getAnswerValue('D4')
                roofAge = this.getAnswerValue('D2')
                required = ((roofMaterial < 0)
                         || (roofMaterial == 402) /* tile */)
                        && ((roofAge < 0)
                         || (roofAge == 204) /* 10-20 yrs old */
                         || (roofAge == 205) /* 20+ yrs old */)
              }
                break;
        }
        return { id: q.id, // This is not required, but helps with debugging
            required: required, answered: answered, mayBeUntouched: mayBeUntouched,
            nextIndex: -1, prevIndex: -1, hasNext: false, hasPrev: false}
    });
    let lastIndex = -1;
    for (let i = 0; i < qm.length; i++) {
        qm[i].prevIndex = lastIndex;
        qm[i].hasPrev = lastIndex >= 0;
        if (qm[i].required) {
            if (lastIndex >= 0) {
                qm[lastIndex].nextIndex = i;
                qm[lastIndex].hasNext = true;
            }
            lastIndex = i;
        }
    }
    // console.log('** qm **')
    // console.log(qm)
    return qm;
  },
  // eslint-disable-next-line no-unused-vars
  calcCompletionRatio(qm, activeIndex) {
      let nNotRequired = 0
      let nAnswered = 0
      for (let i = 0; i < qm.length; i++) {
          const qmi = qm[i];
          nAnswered += (qmi.required && qmi.answered) ? 1 : 0    
          nNotRequired += (qmi.required ? 0 : 1)
      }
      return (nAnswered + nNotRequired) / qm.length;
  },
  getCompletionRatio(activeIndex) {
      return this.calcCompletionRatio(this.getQuestionMap(), activeIndex)
  },
  getLastQuestionIndex(qm) {
      for (let i = qm.length - 1; i > 0; i--) {
          if (qm[i].required)
              return i;
      }
  },

};

export default completionMap;
